import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import { API_BASE_URL } from '@/config/index.js'
import ElementUI from 'element-ui';

export default {
	setFormData(data) {
		let formData = '';
		for (let p in data) {
			formData += p + '=' + data[p] + '&';
		}
		return formData.slice(0, -1);
	},
	install() {
		Vue.prototype.ajax = (type, url, option = {}, callback) => {
			let apiurl = url;
			let formData = {}, contentType = 'application/json'
			if (option['Content-Type']) {
				contentType = option['Content-Type']
			}
			if (type == 'get' && option) {
				apiurl += '?' + qs.stringify(option);
			} else {
				delete option['Content-Type'];
				if (contentType == 'application/json') {
					formData = JSON.stringify(option);
				} else {
					formData = qs.stringify(option);
				}
			}
			return axios({
				method: type,
				// url: (process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/api' :
				// 	API_BASE_URL) + apiurl,
				url:(process.env.NODE_ENV !== 'production' && process.env.OPEN_PROXY ? '/index.php/api' :
				API_BASE_URL) + '/index.php' + apiurl,
				data: formData,
				headers: {
					'Content-Type': contentType,
					// 'token': sessionStorage.getItem('token'),
					'token': localStorage.getItem('user_token') || ''
				}
			}).then(res => {
				// let that = Vue
				// console.log('res==',res)
				// if(!res){
				//   Vue.$router.push('/')
				// }
				// console.log('res.data.code',res)
				if(res.data.data&&res.data.data.code==201){
					localStorage.removeItem('user_token')
					console.log('res.data.code',res.data.data.msg)
				 return  ElementUI.Message.error(res.data.data.msg);
				}
				if (res) {
					callback && callback(res.data);
				}

			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/assets/js/request.js